import {createAction} from 'redux-act'

export const setGoalModalVisible = createAction('SET_GOAL_MODAL_VISIBLE')
export const setGoalForm = createAction('SET_GOAL_FORM')
export const closeGoalForm = createAction('CLOSE_GOAL_FORM')

// Goal Archive Modal (multi-step: achieved vs archive, future: transfer assets)
export const setGoalArchiveForm = createAction('SET_GOAL_ARCHIVE_FORM')
export const closeGoalArchive = createAction('CLOSE_GOAL_ARCHIVE')


